import { Injectable, signal } from '@angular/core';

// @Injectable()
// export class LoadingService {
//   loading = signal(false);
//   private startTime = 0;
//   private minDuration = 500; // tempo mínimo desejado

//   show() {
//     this.startTime = Date.now();
//     this.loading.set(true);
//   }

//   hide() {
//     const elapsed = Date.now() - this.startTime;
//     const remaining = this.minDuration - elapsed;

//     if (remaining > 0) {
//       setTimeout(() => this.loading.set(false), remaining);
//     } else {
//       this.loading.set(false);
//     }
//   }
// }

// @Injectable({ providedIn: 'root' })
// export class LoadingService {
//   loading = signal(false);
//   private startTime = 0;
//   private minDuration = 400;

//   show() {
//     this.startTime = Date.now();
//     this.loading.set(true);
//   }

//   hide() {
//     const elapsed = Date.now() - this.startTime;
//     const remaining = this.minDuration - elapsed;

//     if (remaining > 0) {
//       setTimeout(() => this.loading.set(false), remaining);
//     } else {
//       this.loading.set(false);
//     }
//   }
// }

@Injectable({ providedIn: 'root' })
export class LoadingService {
  loading = signal(false);
  private requests = 0;

  show() {
    this.requests++;
    this.loading.set(true);
  }

  hide() {
    this.requests--;
    if (this.requests <= 0) {
      this.requests = 0;
      this.loading.set(false);
    }
  }

  reset() {
    this.requests = 0;
    this.loading.set(false);
  }
}
